<ng-template>
    <div class="ap ap-autocomplete-container" data-testid="autocomplete-container">
        <div class="ap-autocomplete-panel" role="listbox" [id]="id" [ngClass]="_classList" #panel data-testid="autocomplete-panel">
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>
